import { OUT_OF_STOCK } from '@jouzen/ecom-components/v3/consts/stockStatus';

import { SIZING_KIT } from '@/app/[locale]/store/_consts';

import Selections from '../_steps/enums/SizeStep';
import WizStepId from '../_steps/enums/WizStepId';
import type { UseButtonDisabledProps } from './useButtonDisabled';

export const useRingsButtonDisabled = ({
  currentStep,
  isAccessory,
  isLoadingPdpData,
  size,
  sizingSelector,
  stockStatus,
}: Partial<UseButtonDisabledProps>) => {
  return (
    Boolean(isLoadingPdpData) ||
    (currentStep === WizStepId.Size &&
      sizingSelector === Selections.ChooseSize &&
      size?.value === SIZING_KIT) ||
    (stockStatus === OUT_OF_STOCK && !isAccessory)
  );
};
